/*
 * Pfanner — cart cross-sell "+" (HPF-24: "Add upselling to cart slideout").
 *
 * Extracted verbatim from the delegated handler that used to live only in
 * sections/main-cart-items.liquid (cart page). Logic is UNCHANGED — this file
 * is a relocation, not a rewrite — so the cart page behaves exactly as before:
 * POST /cart/add.js, patch the header cart bubble from the response, then
 * publish `cartUpdate`.
 *
 * Loaded on BOTH surfaces (see snippets/cart-drawer.liquid and
 * sections/main-cart-items.liquid) because the delegated listener is on
 * `document` and the selector (`.cart-crosssell button[data-cc-add]`) matches
 * either snippets/cart-crosssell.liquid instance — cart page or drawer — with
 * no surface-specific code needed.
 *
 * WHY THE GENERIC `cartUpdate` BROADCAST, NOT A DIRECT drawer/cart-page RENDER
 * (unlike assets/pfanner-pfand.js / assets/pfanner-gift.js, which render
 * `cart-drawer` + `main-cart-items` sections directly from their own POST):
 * this handler is a discrete, already-correct one-shot pattern that Dawn's own
 * CartItems class (assets/cart.js) already resolves per surface — `<cart-items>`
 * (cart page) and `<cart-drawer-items>` (drawer, a CartItems subclass) each
 * override `onCartUpdate()` to re-render THEMSELVES: the drawer refetches
 * `?section_id=cart-drawer` and swaps `cart-drawer-items` + `.cart-drawer__footer`
 * (never the cart page's sections), the cart page refetches `main-cart-items` and
 * swaps its own innerHTML. Reusing that path — rather than hand-rolling a second,
 * slightly different reconciler — keeps the two surfaces byte-identical in
 * behaviour and is why the cart page needed no logic change to gain the drawer.
 * assets/pfanner-pfand.js / assets/pfanner-gift.js need their own direct render
 * because they are background reconcilers that fire on every `cartUpdate` with
 * loop-guards; this handler only ever runs from a direct user click.
 */
(function () {
  if (window.__pfannerCartCrosssell) return;
  window.__pfannerCartCrosssell = true;

  function updateBubble(sections) {
    if (!sections) return;
    var html = sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    var frag = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (frag) bubble.innerHTML = frag.innerHTML;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-crosssell button[data-cc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var id = parseInt(btn.getAttribute('data-cc-add'), 10);
    if (!id) return;
    btn.setAttribute('aria-disabled', 'true');
    fetch((window.routes ? window.routes.cart_add_url : '/cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-icon-bubble'] }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { btn.removeAttribute('aria-disabled'); return; }
        updateBubble(data.sections);
        // pubsub.js declares PUB_SUB_EVENTS as a `const` (a lexical global, NOT a
        // window property), so it must be referenced bare — `window.PUB_SUB_EVENTS`
        // is undefined. Publishing cartUpdate makes every subscribed CartItems
        // instance re-render itself in place: <cart-items> on the cart page,
        // <cart-drawer-items> in the drawer (whichever is present/subscribed).
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-crosssell', cartData: data });
        }
        // The re-render replaces this button's node, so no need to re-enable it.
      })
      .catch(function () { btn.removeAttribute('aria-disabled'); });
  });
})();
